import React from "react";

const Java_Encapsulation = () => {
  return (
    <div>
      <h1>Java Encapsulation</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Encapsulation in Java.</p>
    </div>
  );
};

export default Java_Encapsulation;
